import { Ng2StateDeclaration } from "@uirouter/angular";
import { GlobalSearchComponent } from "@webapp/search/components/global-search/global-search.component";
import { removeFullNavSkeleton } from "@webapp/shared/skeleton/skeleton.utils";

export const states: Ng2StateDeclaration[] = [
  {
    name: "gtmhub.search2",
    url: "/search-2",
    component: GlobalSearchComponent,
    onEnter: (): void => {
      removeFullNavSkeleton({ force: true });
    },
    data: { requiresLogin: true },
  },
];
